export function capitalizeFirstLetter(string) {
  return string[0].toUpperCase() + string.slice(1);
}

export function getBackendAssetURL() {
  return process.env.REACT_APP_BACKEND_API_URL;
}

export function getBackendURL() {
  return process.env.REACT_APP_BACKEND_API_URL + '/api';
}

export function getBackendURLWithSuffix(suffix) {
  return process.env.REACT_APP_BACKEND_API_URL + `/api/${suffix}`;
}

export function setAndClear(message, prop) {
  prop(message);
  setTimeout(() => prop(''), 1500);
}

export function getTodayDate() {
  const date = new Date();
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
}

export function getDateInFormat(dateString) {
  const date = new Date(dateString);
  return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
}

export function getSubRoutePath(user) {
  return user.level === 0 ? 'admin' : 'distributor';
}

export function isUserAccountExpired(userAccountExpiryDate) {
  let numbers = userAccountExpiryDate.split('/');
  let correctDate = `${numbers[1]}/${numbers[0]}/${numbers[2]}`;
  let today = new Date();
  let site = new Date(correctDate);
  if (
    `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear()}` ===
    correctDate
  ) {
    return false;
  }
  return today.getTime() > site.getTime();
}

export function getAdvanceDate(createdDate, numberOfMonths) {
  let date = new Date(createdDate);
  return new Date(date.setMonth(date.getMonth() + numberOfMonths));
}

/**
 * Wrapper around fetch that always includes credentials: 'include'
 * so the http-only session cookie is sent with every API request.
 */
export function apiFetch(url, options = {}) {
  return fetch(url, {
    ...options,
    credentials: 'include',
  });
}
